import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import CtaSection from "@/components/CtaSection";
import { STEPS } from "@/data/site";

export default function HowItWorks() {
    return (
        <div>
            <Seo
                title="How It Works | The Sens Civil Works Consultancy"
                description="A simple four-step process — tell us what you need, share documents, consultation or site inspection, and receive documented recommendations."
            />
            <PageHero
                overline="Process"
                title="How It Works"
                description="A simple, transparent engagement process — from first conversation to documented recommendations."
            />

            <section className="blueprint-grid bg-background py-20 lg:py-28" data-testid="process-steps">
                <div className="mx-auto max-w-7xl px-6 lg:px-12">
                    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-4">
                        {STEPS.map((s, i) => (
                            <Reveal key={s.number} delay={i * 0.1} className="h-full">
                                <div
                                    className="relative h-full border border-slate-200 bg-white p-8"
                                    data-testid={`process-step-${s.number}`}
                                >
                                    <p className="font-display text-6xl font-bold tracking-tight text-slate-100">
                                        {s.number}
                                    </p>
                                    <p className="absolute left-8 top-8 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-amber">
                                        Step {s.number}
                                    </p>
                                    <h3 className="mt-6 font-display text-xl font-bold text-navy">{s.title}</h3>
                                    <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.description}</p>
                                    {i < STEPS.length - 1 && (
                                        <ArrowRight
                                            size={18}
                                            className="absolute -right-3 top-1/2 hidden -translate-y-1/2 text-slate-300 xl:block"
                                            aria-hidden="true"
                                        />
                                    )}
                                </div>
                            </Reveal>
                        ))}
                    </div>
                    <Reveal delay={0.2}>
                        <div className="mt-16 border border-slate-200 bg-white p-8 lg:p-12">
                            <div className="flex flex-wrap items-center justify-between gap-6">
                                <div>
                                    <h2 className="font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl">
                                        Ready when you are
                                    </h2>
                                    <p className="mt-2 max-w-xl text-sm leading-relaxed text-slate-600">
                                        Most engagements begin with a ten-minute conversation. Scope and fee are agreed
                                        before any work starts — no surprises.
                                    </p>
                                </div>
                                <Link
                                    to="/contact"
                                    className="inline-flex items-center gap-2 bg-amber px-7 py-4 font-mono text-xs font-semibold uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:bg-amber-hover"
                                    data-testid="start-consultation-btn"
                                >
                                    Start Your Consultation <ArrowRight size={14} />
                                </Link>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </section>

            <CtaSection />
        </div>
    );
}
